import gql from "graphql-tag";

export default gql`query QuotesCallback {
  quotesCallback {
    id
    name
    total
    totalClass
    telephone
    timestamp
    quoteType{
      id
      abbreviation
    }
  }
  }`